import { Button, Col, Modal, Row, message } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomTable from '../../../v2-components/Antd/Table';
import Loading from '../../../v2-components/Loading';
import { Service } from '../service';
import { RecipesModule } from './components/RecipesModule';
import StatusCard from './components/StatusCard';
import TrackingProgress from './components/TrackingProgress';
import { dictionaryInformation } from './constants/dictionary-information.constant';
import { cleanEmptyFields } from './handle/clean-empty-fields.constant';
import { clientInfoAdapter } from './handle/client-info-adapter.handle';
import { generateClientColumns } from './handle/gererate-client-columns.handle';
import { mapRecipesToCommercialProductsPayload } from './handle/map-recipe-to-commercial-product-format.handle';
import { maprecipeToProfessionalFormat } from './handle/map-recipe-to-professional-format.handle';
import { mapRecipesToMagistralPayload } from './handle/map-recipes-to-magistral-payload.handle';
import { mapRecipesToMagistralToMakePayload } from './handle/map-recipes-to-magistral-to-make-payload.handle';
import { validateRecipes } from './handle/validate-recipes.handle';
import dayjs from 'dayjs';
import './style.scss';

export default function QuotationDetailPage() {
	const { id } = useParams();
	const [data, setData] = useState();
	const [isError, setError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { email, token } = GetLocalStorageValue('userInfo')
	const [products, setProducts] = useState([])

	const status = data?.status_tracking;
	const dataClient = data?.user_info;
	const statusNumber = data?.status_tracking?.status;
	const recipesRef = useRef([]);
	const [reloadKey, setReloadKey] = useState(0);
	const history = useHistory()



	
const formattedRecipes = useMemo(() => {
  return (data?.recipe || []).map((recipe) => {
    
 
		const commercialProducts = (data?.commercial_products || [])
        .filter((product) => product.recipe_id === recipe.id)
        .map(p => ({
            ...p,
            sku:  p.id_pharol, 
        }));

		
		const magistralProducts = (data?.magistral_products || [])
        .filter((product) => product.recipe_id === recipe.id)
        .map(p => ({
            ...p,
            discount_percent: p.discount?.value || 0,
            discount: undefined 
				}));
		
		const magistralToMake = (data?.magistral_products_prepare || [])
        .filter((product) => product.recipe_id === recipe.id)
        .map(p => ({
            ...p,
            discount_percent: p.discount?.value || 0,
            discount: undefined 
        }));


    return {
      ...recipe,
      products: {
        commercial: commercialProducts,
        magistralFinished: magistralProducts, 
        magistralToMake: magistralToMake 
      }
    };
  });
}, [data]);



	useEffect(() => {
		setIsLoading(true)
		new Service().getDataById(id)
			.then((dataResponse) => {
				setData(dataResponse);
				setIsLoading(false)
			})
			.catch((error) => {
				setIsLoading(false);
				setError(true);
			});
	}, [id, reloadKey]);

	const handleOnPersist = useCallback((allRecipes) => {

    const allMagistralFinished = allRecipes.flatMap(
      (recipe) => recipe.products.magistralFinished
    );

    const allMagistralToMake = allRecipes.flatMap(
      (recipe) => recipe.products.magistralToMake
    );

    const allMagistralProducts = [
      ...allMagistralFinished,
      ...allMagistralToMake
    ];


    setProducts(allMagistralProducts);
  }, [])

	const handleOnChange = useCallback((allRecipes) => {
		console.log('allRecipes',allRecipes)
		recipesRef.current = allRecipes;
  }, []); // El

	const [isResending, setIsResending] = useState(false);

	const handleUserInfoUpdate = useCallback((fieldKey, newValue) => {
		setData((prevData) => {
			if (!prevData) return prevData;
			const updatedUserInfo = { ...prevData.user_info };
			if (fieldKey === 'name') {
				const parts = newValue.trim().split(/\s+/);
				updatedUserInfo.first_name = parts[0] || '';
				updatedUserInfo.last_name = parts.slice(1).join(' ') || '';
			} else {
				updatedUserInfo[fieldKey] = newValue;
			}
			return { ...prevData, user_info: updatedUserInfo };
		});
	}, []);

	if (isError) {
		return (
			<>
				<Row>
					<Col span={8}>
						<h2>Lo sentimos...</h2>
						<h3>{`La Solicitud N° ${id} no existe`} </h3>
						<Link to={'quotation?status=requested&page=1'}>Volver a cotizaciones</Link>
					</Col>
				</Row>
			</>
		);
	}


	const handleCancelQuotation = (reason) => {
		setIsLoading(true)
		const body = {
			status: 500,
			reason: reason,
			qf_email: email
		}
		new Service().processNewStatus(body, id, token).then((response) => {
			console.log('response',response)
			setIsLoading(false)
			// setRenderData(true)
			setReloadKey(prev => prev + 1);
		}).catch((error) => {
			console.log('error', error)
			setIsLoading(false)
		}
		)
	setIsLoading(false)
	}

	

const handleRemoveRecipe = async (recipe_id) => {
  try {
    await new Service().removeRecipe({ quotationId: id, recipe_id, token });
    
    setData(prevData => {
        if(!prevData) return prevData;
        return {
            ...prevData,
            recipe: prevData.recipe.filter(r => r.id !== recipe_id),
        };
    });
    return true; 

  } catch (error) {
    console.error('Error removing recipe:', error);
    throw error; 
  }
};

	
	
	
	const handleAddRecipe = async (file) => {
		const formData = new FormData();
		formData.append('file', file.originFileObj);
	
		try {
			const uploadResponse = await new Service().uploadImage(formData);
			const uploadedUrl = uploadResponse.files[1]?.file_path || uploadResponse.files[0]?.file_path
	
			if (uploadedUrl) {
				const created_by = "692513b8864acbce65e4b307";
	
				const fullQuotationResponse = await new Service().updateRecipe(
					{ url: uploadedUrl, created_by }, 
					id, 
					token
				);
				const newRecipeFromBackend = fullQuotationResponse.recipe.find(
					(r) => r.url === uploadedUrl
				);
					return newRecipeFromBackend;
			}
		} catch (error) {
			console.error('Error on add recipe:', error);
			throw error;
		}
	};



const handleChangeRecipe = async (file, recipe_id) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const uploadResponse = await new Service().uploadImage(formData);
    const newUrl = uploadResponse.files[1]?.file_path || uploadResponse.files[0]?.file_path
    if (newUrl) {
      const created_by = "692513b8864acbce65e4b307"; 
      await new Service().updateRecipe(
        { url: newUrl, created_by, recipe_id }, 
        id, 
        token
      );
      setData((prevData) => {
        if (!prevData) return prevData;
        return {
          ...prevData,
          recipe: prevData.recipe.map((r) => 
            r.id === recipe_id ? { ...r, url: newUrl } : r
          ),
        };
      });
      return newUrl;
    }
  } catch (error) {
    console.error('Error on change recipe:', error);
    throw error;
  }
};

const handleRequote = async () => {
  setIsLoading(true);
  try {
    const currentRecipes = recipesRef.current;

    const magistralProductIds = currentRecipes.flatMap((recipe) => {
      const finished = recipe.products?.magistralFinished || [];
			const toMake = recipe.products?.magistralToMake || [];
			
			const allMagistrals = [...finished, ...toMake];
      
			return allMagistrals
			.map(p => p.id)
				.filter(id => id);
		});

    const commercialProductIds = currentRecipes.flatMap((recipe) => {
      const commercial = recipe.products?.commercial || [];
      return commercial.map(p => p.id);
    });

    const requotePayload = {
      quotation_id: id,
      magistral_product_ids: magistralProductIds,
      commercial_product_ids: commercialProductIds
    };

   const response = await new Service().requote(requotePayload, token);

		setIsLoading(false);
		
		history.push(`/quotation/detail/${response.id}`)


  } catch (error) {
    console.error("Error en recompra:", error);
    setIsLoading(false);
    Modal.error({ title: "Error", content: "No se pudo procesar la recompra." });
  }
};



const handleApproveQuotation = async () => {
    const currentRecipes = recipesRef.current;

    // Comprobar si alguna receta está vencida (fecha anterior al inicio del día de hoy)
    const todayStart = dayjs().startOf('day');
    const hasExpiredRecipe = (currentRecipes || []).some((recipe) => {
      if (!recipe || !recipe.expiration_date) return false;
      const exp = dayjs(recipe.expiration_date);
      if (!exp.isValid || (typeof exp.isValid === 'function' && !exp.isValid())) return false;
      return exp.isBefore(todayStart, 'day');
    });

    if (hasExpiredRecipe) {
      Modal.error({
        title: 'Error',
        content: 'La receta está vencida. Revisa la fecha de expiración para poder avanzar.',
      });
      return;
    }

    const validationErrors = validateRecipes(currentRecipes);
    if (validationErrors) {
      Modal.error({
        title: 'No se puede enviar la cotización',
        width: 500,
        content: (
          <div style={{ marginTop: '10px' }}>
            <p>Por favor corrige los siguientes errores:</p>
            <ul style={{ color: '#ff4d4f', paddingLeft: '20px' }}>
              {validationErrors.map((err, index) => <li key={index}>{err}</li>)}
            </ul>
          </div>
        ),
      });
      return;
    }

    setIsLoading(true);

    try {

      const recipesList = currentRecipes.map((recipe) => {
        const rawBody = maprecipeToProfessionalFormat(recipe);
        return cleanEmptyFields(rawBody);
      });
      await new Service().updateRecipe({ recipes: recipesList }, id, token);



      const originalCommercialIds = (data?.commercial_products || []).map(p => p.id);
      const allFormCommercials = currentRecipes.flatMap(r => r.products.commercial || []);

      const existingCommercials = allFormCommercials.filter(p => p.id && originalCommercialIds.includes(p.id));
      
      const recipesForNewCommercials = currentRecipes.map(r => ({
        ...r,
        products: { 
            ...r.products, 
            commercial: (r.products.commercial || []).filter(p => !p.id || !originalCommercialIds.includes(p.id)) 
        }
      }));
      const newCommercialPayload = mapRecipesToCommercialProductsPayload(recipesForNewCommercials);

      if (newCommercialPayload.products && newCommercialPayload.products.length > 0) {
        await new Service().addComercialProductsToQuotation(newCommercialPayload, id, token);
      }

      if (existingCommercials.length > 0) {
        const updatePromises = existingCommercials.map((p) => {
          const body = { quantity: Number(p.quantity) };
          return new Service().updateCommercialProducts(body, id, p.id, token);
        });
        await Promise.all(updatePromises);
      }


  
      const originalFinishedIds = (data?.magistral_products || []).map(p => p.id);
      const allFormFinished = currentRecipes.flatMap(r => r.products.magistralFinished || []);

      const existingFinished = allFormFinished.filter(p => p.id && originalFinishedIds.includes(p.id));

      const recipesForNewFinished = currentRecipes.map(r => ({
        ...r,
        products: { 
            ...r.products, 
            magistralFinished: (r.products.magistralFinished || []).filter(p => !p.id || !originalFinishedIds.includes(p.id)),
            magistralToMake: [] 
        }
      }));
      const newFinishedPayload = mapRecipesToMagistralPayload(recipesForNewFinished);

      if (newFinishedPayload.products && newFinishedPayload.products.length > 0) {
        await new Service().addMagistralProductsToQuotation(newFinishedPayload, id, token);
      }

      if (existingFinished.length > 0) {
         const updateBody = {
           products: existingFinished.map(p => ({
             id: p.id,
             code_internal: p.code_internal,
             price: Number(p.price || p.price_unit || 0),
             discount: {
                type: "PERCENTAGE",
                value: Number(p.discount_percent || p.discount?.value || 0)
             },
             quantity: Number(p.quantity),
             recipe_id: p.recipe_id || currentRecipes.find(r => r.products.magistralFinished.some(x => x.id === p.id))?.id
           }))
         };
         await new Service().updateMagistralProducts(updateBody, id, token);
      }


      const originalToMakeIds = (data?.magistral_products_prepare || []).map(p => p.id);
      const allFormToMake = currentRecipes.flatMap(r => r.products.magistralToMake || []);

      const existingToMake = allFormToMake.filter(p => p.id && originalToMakeIds.includes(p.id));

      const recipesForNewToMake = currentRecipes.map(r => ({
        ...r,
        products: { 
            ...r.products, 
            magistralFinished: [], 
            magistralToMake: (r.products.magistralToMake || []).filter(p => !p.id || !originalToMakeIds.includes(p.id))
        }
      }));
      const newToMakePayload = mapRecipesToMagistralToMakePayload(recipesForNewToMake);

      if (newToMakePayload.products && newToMakePayload.products.length > 0) {
        await new Service().addMagistralToMakeProducts(newToMakePayload, id, token);
      }

      if (existingToMake.length > 0) {
         const updateBody = {
           products: existingToMake.map(p => ({
             id: p.id,
             price: Number(p.price_unit !== undefined ? p.price_unit : (p.price || 0)),
             quantity: Number(p.quantity),
             discount: {
                type: "PERCENTAGE",
                value: Number(p.discount_percent || p.discount?.value || 0)
             }
           }))
         };
         await new Service().updateMagistralProducts(updateBody, id, token);
      }


      await new Service().processNewStatus({ status: 300 }, id, token);

      setIsLoading(false);
      setReloadKey(prev => prev + 1);

    } catch (error) {
      console.error('Error al enviar cotización:', error);
      setIsLoading(false);
      Modal.error({ title: "Error", content: "Ocurrió un error al procesar la cotización." });
    }
  };
	
	const handleRemoveCommercialProduct = async (productId) => {
    try {
        await new Service().removeCommercialProduct(productId, id, token);
        

        setData(prevData => {
            if (!prevData) return prevData;
            
            const oldList = prevData.commercial_products || [];
            const newList = oldList.filter(p => {
                return p.id !== productId;
            });
            

            return {
                ...prevData,
                commercial_products: newList
            };
        });
        return true;
    } catch (error) { 
			console.error("Error eliminando producto comercial:", error);
			throw error;
		}
}

const handleRemoveMagistralProduct = async (productId) => {
	await new Service().removeMagistralProduct(productId,id,token)
}

const handleResendQuotationEmail = async () => {
	setIsResending(true);
	try {
		await new Service().resendQuotationEmail(id, token);
		message.success('Cotización reenviada correctamente');
	} catch (error) {
		console.error('Error al reenviar cotización:', error);
		message.error('Error al reenviar la cotización');
	} finally {
		setIsResending(false);
	}
};



	if (isLoading) {
		return <Loading />;
	}
	return (
		<div className="ph-tracking-order-detail-page-container">
			<Row justify="space-between" align="middle">
				<Col>
					<h2>{`Solicitud N° ${data?.short_code}`} </h2>
					<Link to={'/quotation?status=100&page=1'}>Volver a cotizaciones</Link>
				</Col>
				{statusNumber === 400 && (
					<Col>
						<Button
							type="primary"
							loading={isResending}
							onClick={handleResendQuotationEmail}
						>
							Reenviar cotización
						</Button>
					</Col>
				)}
			</Row>
			<Row>
				<Col span={12}>
					<TrackingProgress data={data} />
				</Col>
				<Col span={12}>
					<CustomCard >
						<StatusCard
              dataClient={dataClient}
							products={products}
							statusNumber={statusNumber}
              trx_id={data?.trx_id}
							status={status}
							handleCancelQuotation={handleCancelQuotation}
							handleApproveQuotation={handleApproveQuotation}
							handleRequote = {handleRequote}
							quotationData={data}
							quotationId={id}
							onPurchaseSuccess={() => setReloadKey(prev => prev + 1)}
						/>
					</CustomCard>
				</Col>
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].client}</h3>
					<CustomTable columns={generateClientColumns({ statusNumber, quotationId: id, token, onUserInfoUpdate: handleUserInfoUpdate })} pagination={false} dataSource={clientInfoAdapter(dataClient)} />
					<RecipesModule
						handleRemoveMagistralProduct={handleRemoveMagistralProduct}
						handleRemoveCommercialProductService={handleRemoveCommercialProduct}
						initialRecipes={formattedRecipes}
						onPersist={handleOnPersist}
						onChange={handleOnChange}
						statusNumber={statusNumber}
						handleRemoveRecipeService={handleRemoveRecipe}
						handleAddRecipeService={handleAddRecipe}
						handleChangeRecipeService= {handleChangeRecipe}
					/>
				</Col>
				<Row>

				</Row>
			</Row>
		</div>
	);
}
